import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from '../../material.module';

import { DialogAlertComponent } from './alert/dialog-alert.component';
import { DialogInputComponent } from './input/dialog-input.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { StatusInfoDialogComponent } from './status-info/status-info-dialog.component';

import { ValidationModule } from '../validation/validation.module';

@NgModule({
  providers: [],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, MaterialModule, ValidationModule],
  declarations: [DialogAlertComponent, DialogInputComponent, ConfirmDialogComponent, StatusInfoDialogComponent],
  exports: [DialogAlertComponent, DialogInputComponent, ConfirmDialogComponent, StatusInfoDialogComponent],
  entryComponents: [DialogAlertComponent, ConfirmDialogComponent, StatusInfoDialogComponent],
})
export class DialogModule {}
